import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { environment as env } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    public env = env;
    @ViewChild('contactFormNgForm') contactFormNgForm: NgForm;

    alert: { type: "success" | "error"; message: string } = {
        type   : 'success',
        message: ''
    };
    showAlert: boolean = false;
    canShowBoxA = true;
    contactForm: FormGroup;
    private _basePathapi = env.url + env.api_cli;
    private langChangeSubscription: any;

    constructor(
        public router: Router,
        private _formBuilder: FormBuilder,
        private _httpClient: HttpClient,
        private translate: TranslateService,
    ) {
      this.router.events.subscribe( (val: any) => {
        this.activateDiv(this.router.url);
      });
      this.alert.message = this.translate.instant('contact-form-sent');

      this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {
        this.alert.message = this.translate.instant('contact-form-sent');
      });
    }
    ngOnDestroy() {
      // Desuscribirse cuando el componente se destruye para evitar fugas de memoria
      this.langChangeSubscription.unsubscribe();
    }

    activateDiv(url: string) {
      if(url === "/quotation/step2") {
        this.canShowBoxA = false;
      }
    }

    ngOnInit(): void {

      function noWhiteSpaceValidator(control: FormControl) {
        const isWhiteSpace = (control.value || '').trim().length === 0;
        const isValid = !isWhiteSpace;
        return isValid ? null : { 'whitespace': true };
      }
      
        // Create the form
      this.contactForm = this._formBuilder.group({
        name: ['', [Validators.required, noWhiteSpaceValidator]],
        // surname: ['', [Validators.required]],
        city: ['', [Validators.required, noWhiteSpaceValidator]],
        // type: ['', [Validators.required]],
        // payment: ['', [Validators.required]],
        message: ['', [Validators.required, noWhiteSpaceValidator]],
        phone: ['', [Validators.required,Validators.pattern("\\+?[-\\/0-9 ]{0,15}$"), noWhiteSpaceValidator]],
        email: ['', [Validators.required, Validators.email, noWhiteSpaceValidator]]
        });
    }
    
    get name() { return this.contactForm.get('name'); }
    get phone() { return this.contactForm.get('phone'); }
    get city() { return this.contactForm.get('city'); }
    // get surname() { return this.contactForm.get('surname'); }
    // get type() { return this.contactForm.get('type'); }
    // get payment() { return this.contactForm.get('payment'); }
    get email() { return this.contactForm.get('email'); }
    get message() { return this.contactForm.get('message'); }
    //get massage() { return ("Tipo servicio: "+this.contactForm.get('type') + " Monto pago: "+this.contactForm.get('payment'))};

    submitForm() {
        //console.log(this.contactForm.value)
        let a = this.contact(this.contactForm.value);
        this.contact(this.contactForm.value)
          .pipe(
              finalize(() => {
    
                  // Re-enable the form
                  this.contactForm.enable();
                  this.showAlert = true;
              })
          )
          .subscribe(
              (response) => {
    
                // Reset the form
                this.contactFormNgForm.resetForm();
                
                  // Set the alert
                  this.alert = {
                      type   : 'success',
                      message: this.translate.instant('contact-form-sent')
                  };
              },
              (error) => {
    
                  // Set the alert
                  this.alert = {
                      type   : 'error',
                      message: this.translate.instant('contact-form-error')
                  };
              }
          );
    }

    contact(form: FormBuilder): Observable<any>
  {
    let header_node = {
      headers: new HttpHeaders(
          { 'Accept': 'application/json'
          //, 'rejectUnauthorized': 'false', // Produce cors error: 'Resource Sharing Error: HeaderDisallowedByPreflightResponse' // Pendiente de encontrar la forma de habilitarlo en python, por si nos hace falta.
        })
      };

    return this._httpClient.post(this._basePathapi + 'contact/', form, header_node);
  }

}
